<template>
  <div>
    <!-- div style = "position: absolute; left: 483px; top: 355px"><img src="../assets/fixation.png"></div -->
    <!-- button
      type="button"
      name="endInstructions"
      class="btn btn-secondary"
      style="right: 20px; bottom: 20px; position: absolute;"
      @click="end()">End</button -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import StateMixin from '../mixins/State'
export default {
  mixins: [ StateMixin ],
  data () {
    return {
      data: undefined
    }
  },
  mounted () {
    var blockTimer = 2000
    this.blockTimer = setTimeout(() => {
      this.next()
    }, blockTimer)
  },
  methods: {
    next: function () {
        //this.$router.replace('/cue')
      if(this.$route.params.stage === "training") {
        this.$router.replace('/training_cue')
      }else{
        this.$router.replace('/cue')
      }
    },
    end: function () {
      clearTimeout(this.blockTimer)
      this.$router.replace('/complete')
    }
  }
}
</script>

<style type="text/css">
  .centerbox {
    width: 50vw;
    height: 40vh;
    position:absolute;
    top:30%;
    left:50%;
    margin-right:-50%;
    transform: translate(-50%,-50%);
  }
  .outcomeMessage {
    text-align: center;
    position: relative;
    font-size: 3em;
    top: 40%;
    transform: translateY(-40%);
    -webkit-transform: translateY(-40%);
  }
</style>